import { Component } from "@angular/core";


@Component({
  selector: 'mood-too-many-downloads-dialog',
  templateUrl: 'too-many-downloads-dialog.component.html',
  styleUrls: ['too-many-downloads-dialog.component.scss']
})
export class TooManyDownloadsDialogComponent {
  constructor() {}
}
